import { integrationMiddleware } from "../network/middlewareHttp";
import { AxiosInstance } from "axios";
import { baseURL } from "./FetchUrl";

class StorageCatalog{
    apiURL = baseURL
    getEndpoint = '/api/Storage/get'
    postEndpoint = '/api/Storage/post'
    putEndpoint = '/api/Storage/put'
    deleteEndpoint = '/api/Storage/delete'
    http = integrationMiddleware(this.apiURL, 'AUTH TOKEN')

    getStorageList = async(filter) => {
        return new Promise(async(resolve, reject) => {
            this.http.get(this.apiURL + this.getEndpoint + "?filter=" + (filter ? "true" : "false"))
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }
    postStorage = async(body) => {
        return new Promise(async(resolve, reject) => {
            this.http.post(this.apiURL + this.postEndpoint, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    deleteStorage = async(id) => {
        return new Promise(async(resolve, reject) => {
            this.http.delete(this.apiURL + this.deleteEndpoint + '/' + id )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    updateStorage = async(id, body) => {
        return new Promise(async(resolve, reject) => {
            this.http.put(this.apiURL + this.putEndpoint + '/' + id, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

}

export default StorageCatalog
